import { ImpactModule } from 'types'
import { SERVICES_LETTER_PAGES } from './pages'
import { SERVICES_LETTER_PAGES_ORDER_FOR_PERMISSIONS } from './pagesOrderForPermissions'

export const SERVICES_LETTER_MODULE: ImpactModule = {
  NAME: 'service',
  UPPER_NAME: 'SERVICE',
  API_NAME: 'SERVICE',
  NAME_PTBR: 'Cartas de Serviços',
  PAGES: SERVICES_LETTER_PAGES,
  PAGES_ORDER_FOR_PERMISSIONS: SERVICES_LETTER_PAGES_ORDER_FOR_PERMISSIONS,
}
